import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { Box, CircularProgress, Grid, IconButton, Typography } from '@material-ui/core';
import EmployeeExcel from '../../../../assets/images/NewEmployee/exampleImport.png'
import { Close, CloudDownload, CloudUpload } from '@material-ui/icons';
import modelo from '../../../../assets/images/modelo_importacao_puntu.xlsx'


const NewImportEmployee = ({
    open,
    viewEmployeeRegistration
}) => {

    const fileInputRef = React.useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            console.log('Arquivo selecionado:', event.target.files[0]);
            viewEmployeeRegistration.sendImportEmployee(event.target.files[0])
        }
    };

    return (

        <Dialog
            open={open}
            onClose={viewEmployeeRegistration.handleCloseModalImport}
            maxWidth="md"
            fullWidth
            PaperProps={{
                style: { borderRadius: 20 }
            }}
        >
            <DialogTitle style={{ textAlign: 'center', position: 'relative', color: '#314158', fontFamily: 'montserrat' }}>
                Importar colaboradores
                <IconButton
                    aria-label="close"
                    onClick={viewEmployeeRegistration.handleCloseModalImport}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#484fdb',
                        border: '1px solid #484fdb', // Adiciona a borda azul
                        borderRadius: '50%', // Faz a borda ser um círculo
                        padding: '5px' // Ajusta o padding para garantir que o círculo fique ao redor do ícone
                    }}
                >
                    <Close style={{color:'#484fdb'}}/>
                </IconButton>

            </DialogTitle>
            <DialogContent style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center', // Centraliza o texto
                padding: 0,
                overflow: 'hidden', // Garante que a imagem não ultrapasse os limites do diálogo
            }}>
                <Typography style={{ color: '#314158', fontFamily: 'montserrat' }}>O arquivo excel deve conter o padrão da imagem abaixo.</Typography>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                    height="100%"
                    style={{
                        backgroundImage: `url("${EmployeeExcel}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        height: '300px', // Ajuste a altura conforme necessário
                        width: '800px',
                        borderRadius: 20
                    }}
                >
                </Box>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                <Button
                    style={{
                        backgroundColor: 'white',
                        color: '#484fdb',
                        border: '1px solid #484fdb',
                        marginRight: '10px', // Espaçamento entre os botões
                        borderRadius: 15,
                        textTransform: 'none'
                    }}
                    onClick={() => viewEmployeeRegistration.sheetDownload(modelo, 'modelo_importacao.xlsx')}
                >
                    <CloudDownload style={{ marginRight: '10px' }} />
                    Baixar modelo
                </Button>
                <div>
                    <input
                        id="contained-button-file"
                        multiple
                        type="file"
                        accept=".xlsx,.ods"
                        style={{ display: 'none' }}
                        ref={fileInputRef}
                        onChange={handleFileChange}
                    />
                    <Button
                        style={{
                            backgroundColor: '#484fdb',
                            color: 'white',
                            borderRadius: 15,
                            textTransform: 'none'
                        }}
                        onClick={handleButtonClick}
                    >
                        <CloudUpload style={{ marginRight: '10px' }} />
                        Importar Planilha
                    </Button>
                </div>
            </DialogActions>

        </Dialog>

    );
};

export default NewImportEmployee;
